// pages/TravelExpense/travelCase.js
//
// Go-live parity (2026-09-24): the API serializes responses in camelCase
// (ASP.NET default — items, count, trip, log, destinations, employeeIds, …),
// but the Travel pages read PascalCase envelopes (data.Items, data.Trip, …),
// so every list was empty and every trip showed "Trip not found".
// toCamel() normalizes a response (recursively) to camelCase keys, so the
// pages read camelCase with a PascalCase fallback: when both spellings of a
// key are present the camelCase value wins.

const lowerFirst = (k) => (k ? k.charAt(0).toLowerCase() + k.slice(1) : k);

export const toCamel = (value) => {
    if (Array.isArray(value)) return value.map(toCamel);
    if (value && typeof value === "object" && Object.getPrototypeOf(value) === Object.prototype) {
        const out = {};
        Object.keys(value).forEach((k) => {
            const ck = lowerFirst(k);
            if (k === ck || !(ck in value)) out[ck] = toCamel(value[k]);
        });
        return out;
    }
    return value;
};

export default toCamel;
